import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button,  Col, Container,  Input, FormGroup,  Row,FormFeedback } from 'reactstrap';
import {validationSchema,validate} from './ValidationSchema';
import { Formik,Form } from 'formik';
import axios from '../../../containers/Axios/Config';
import Modals  from '../../../containers/ModalAlerts/ModalAlerts';
import { GoogleLogin } from 'react-google-login';
// import { LinkedIn } from 'react-linkedin-login-oauth2';
import voboIcon from '../../../assets/img/brand/voboicon.png';
import voboLogo from '../../../assets/img/brand/VoboLogo_lightGreen.png';

class Login extends Component {

    state = {
          email: '',
          password: '',
          successMessage:undefined,
          error:null,
          apiStatus:undefined,
          modalPopup:undefined,
          redirectUrl:undefined,
    };
    
    /**
     * on Google login Success
     */
    onGoogleSuccess=(response)=>{    
      if(response.profileObj){
        axios.post('company/user/social/signin', {email:response.profileObj.email})
        .then(response => {   
            if (response.data.status === 200) {
                this.storedataInLocal(response)
            }else{
                console.error('Registration failed'); 
            }
        })
        .catch(function (error) {
            this.setState({
              successMessage:undefined,
              error:error,
              apiStatus: false,
              modalPopup:true,
              redirectUrl:undefined,
          });
          }.bind(this));
    }
  }

  /**
   * Storing data in local stroage
   */
  storedataInLocal=(response)=>{
    localStorage.setItem("UserRole", response.data.data.user.userRole.roleName);
      localStorage.setItem("testUser", response.data.data.testUser);
      localStorage.setItem("iotToken", response.data.data.token);
      localStorage.setItem("iotUser",response.data.data.user._id);
      localStorage.setItem("companyId",response.data.data.user.company._id);
      localStorage.setItem("emailId",response.data.data.user.company.email);
      localStorage.setItem("accountId",response.data.data.user.company.accountid);
      localStorage.setItem("userName",response.data.data.user.fullName);      
      axios.defaults.headers.common['Authorization'] = localStorage.getItem("iotToken");
      this.setState({
          email: '',
          password: '',
          redirectToReferrer: true,
          modalPopup:false,
      });  
      this.props.history.push("/home");
    }

    /**
     * on Login Submit
     */
    onSubmit = (values, { setSubmitting, setErrors }) => {
      setSubmitting(true)
        axios.post('company/user/signin', {"email":values.email,"password":values.password})
        .then(response => {     
            if (response.data.status===200) {
              setSubmitting(false)
              this.storedataInLocal(response)             
            }else{
                console.error('login failed'); 
            }
        })
        .catch(function (error) {
            setSubmitting(false)
            this.setState({
              successMessage:undefined,
              error:error,
              apiStatus: false,
              modalPopup:true,
          });
          }.bind(this));
    }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="3">
              <a href="http://www.vobo.ai/">
                <div id="over">
                  {/* <img src={voboIcon} alt="Vobo Icon"/> */}
                  <img src={voboLogo} alt="Vobo Logo" height="75px"/>
                </div>
              </a>
              <Row  className="mb-2">
                <Col md="12">
                <Formik
                  initialValues={this.state}
                  validate={validate(validationSchema)}
                  onSubmit={this.onSubmit}
                  render={
                    ({
                      values,
                      errors,
                      touched,
                      status,
                      dirty,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      isValid,
                      handleReset,
                      setTouched
                    }) => (
                    <Form onSubmit={handleSubmit} noValidate name='simpleForm' >
                        <h4 className="mb-4 ">Login to your account</h4>
                        <FormGroup className="mb-3">
                          <Input type="text"
                                  name="email"
                                  id="email"
                                  placeholder="Please enter your email"
                                  autoComplete="email"
                                  valid={!errors.email}
                                  invalid={touched.email && !!errors.email}
                                  required
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.email} />
                        <FormFeedback>{errors.email}</FormFeedback>
                        </FormGroup>
                        <FormGroup className="mb-3">
                          <Input type="password"
                                      name="password"
                                      id="password"
                                      placeholder="Please enter your Password"
                                      autoComplete="password"
                                      valid={!errors.password}
                                      invalid={touched.password && !!errors.password}
                                      required
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.password} />
                          <FormFeedback>{errors.password}</FormFeedback>
                        </FormGroup>
                        {/* <FormGroup className="mb-3 text-right">
                          <Link to="/forgotpassword">
                            <p className="vobodark">Forgot Your Password?</p>
                          </Link>
                        </FormGroup> */}
                        <Row>
                          <Col xs="12">
                            <Button type="submit" color="vobo" className="px-4" style={{width:'100%'}}  disabled={isSubmitting }>{isSubmitting ? 'Submitting' : 'Login'} </Button>
                          </Col>
                        </Row>
                      </Form>
                  )} />
                  </Col>
                  </Row>
                  <Row className="justify-content-center">
                    <Col className="or">
                      <hr></hr>
                      <p className="text-muted align-items-center pt-1" >OR</p>
                      <hr></hr>
                    </Col>
                  </Row>
                 
                  <Row className='mb-3 justify-content-center'>
                    {/* <Col lg={12} className="justify-content-center"> */}
                        {/* <GoogleLogin
                          clientId="648622628607-p97ddtu0l2ogj06ltq4tmea4m1pne7rl.apps.googleusercontent.com"
                          buttonText="Login with Google"
                          theme="dark"
                          onSuccess={this.onGoogleSuccess}
                          onFailure={this.onGoogleFailure}
                        /> */}
                    {/* </Col> */}
                   
                        
                        {/* <GoogleLogin
                          clientId="648622628607-p97ddtu0l2ogj06ltq4tmea4m1pne7rl.apps.googleusercontent.com"
                          // render={renderProps => (
                          //   <Button type="button" color="primary" className="px-4 w-100"  onClick={renderProps.onClick}> Google </Button>
                          // )}
                         
                          buttonText=" Login"
                          onSuccess={this.onGoogleSuccess}
                          onFailure={this.onGoogleFailure}
                        /> */}
                   
                    {/* <LinkedIn
                          clientId="81okiuklhg2e4y"
                          callBack={this.handleSuccess}
                         
                          // className={'className'}
                          text={'Login with Linkedin'}
                        /> */}
                     {/* <LinkedIn
                        clientId="81okiuklhg2e4y"
                        onFailure={this.handleFailure}
                        onSuccess={this.handleSuccess}
                        redirectUri="http://localhost:3004/#/linkedin"
                      > */}
                       {/* <Button type="button" color="primary" className="px-4" >Sign in with Google </Button> */}
                      {/* </LinkedIn> */}
                    
                  </Row>
                  <Row align="center">
                    <Col lg={12}>                      
                      New to IOT? {' '}
                        <Link to="/register">
                       Sign Up
                        </Link>                      
                    </Col>
                  </Row>
            </Col>
          </Row>
        </Container>
        { this.state.modalPopup? <Modals successMessage={this.state.successMessage} error={this.state.error} apiStatus={this.state.apiStatus} redirectUrl={this.state.redirectUrl}/>: null }
      </div>
    );
  }
}

export default Login;
